<template>
  <v-container id="sponsors" fluid>
    <h1 class="primary--text mt-3">
      Gastgeber
    </h1>

    <v-layout row wrap>
      <template v-for="(item, index) in hosts">
        <v-flex :key="index" xs12 md6>
          <v-card
            color="white"
            class="mt-4"
            :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }"
          >
            <div class="pt-4 pb-3">
              <v-img
                :src="require('../assets/images/hosts/' + item.image)"
                :height="item.height"
                contain
                class="mx-auto"
              />
            </div>

            <v-card-title>
              <div>
                <h3 class="headline mb-3">{{ item.title }}</h3>
                <div v-html="item.text" />
              </div>
            </v-card-title>

            <v-divider light />
            <v-card-actions v-if="item.link">
              <v-btn flat color="accent" :href="item.link" target="_blank">
                Website
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </v-layout>

    <h1 class="primary--text mt-5">
      Unterstützer
    </h1>

    <v-layout row wrap>
      <template v-for="(item, index) in sponsors">
        <v-flex :key="index" xs12 md6>
          <v-card
            color="white"
            class="mt-4"
            :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }"
          >
            <div class="pt-4 pb-3">
              <v-img
                :src="require('../assets/images/sponsors/' + item.image)"
                :height="item.height"
                contain
                class="mx-auto"
              />
            </div>

            <v-card-title>
              <div>
                <h3 class="headline mb-3">{{ item.title }}</h3>
                <div v-html="item.text" />
              </div>
            </v-card-title>

            <v-divider light />
            <v-card-actions v-if="item.link">
              <v-btn flat color="accent" :href="item.link" target="_blank">
                Website
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </v-layout>

    <h1 class="primary--text mt-5">
      Medienpartner
    </h1>

    <v-layout row wrap>
      <template v-for="(item, index) in media">
        <v-flex :key="index" xs12 md6>
          <v-card
            color="white"
            class="mt-4"
            :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }"
          >
            <div class="pt-4 pb-3">
              <v-img
                :src="require('../assets/images/media/' + item.image)"
                :height="item.height"
                contain
                class="mx-auto"
              />
            </div>

            <v-card-title>
              <div>
                <h3 class="headline mb-3">{{ item.title }}</h3>
                <div v-html="item.text" />
              </div>
            </v-card-title>

            <v-divider light />
            <v-card-actions v-if="item.link">
              <v-btn flat color="accent" :href="item.link" target="_blank">
                Website
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      sponsors: [
        {
          title: 'Sparkasse Vorpommern',
          text: 'Die Sparkasse ist Ihr starker Partner in der Region Vorpommern. Bei uns stehen Sie als Mensch & Kunde im Mittelpunkt und erleben Tag für Tag die Verbindung von Tradition & Moderne.<br>Sie entscheiden, wie und wo Sie Ihre Finanzgeschäfte abwickeln – ganz klassisch in der Filiale oder lieber daheim am PC? Mittels Online-Banking, ganz modern per Smartphone-App oder telefonisch in der Sparkassen-Media-Filiale?<br>An 365 Tagen im Jahr sind wir für Sie erreichbar, rund um die Uhr und in jeder Phase Ihres Lebens. Vom ersten Konto, über die Finanzierung Ihres Unternehmens, auf dem Weg in die eigenen vier Wände und bis zur richtigen Altersvorsorge.',
          image: 'sparkasse-vorpommern.png',
          link: 'https://www.spk-vorpommern.de',
          height: '100'
        },
        {
          title: 'Euler Hermes',
          text: 'Sie treffen das gesamte Jahr über Entscheidungen, die tiefe Einblicke in Ihre Märkte und den Konjunkturzyklus verlangen. Dabei unterstützen sollen sie Finanzierungsinstrumente, die Ihren Plänen größere Sicherheit verleihen sollen. Seit über 100 Jahren investieren wir in Daten. Heute können wir sagen: Unsere weltweiten Informationen über Unternehmen sind unübertroffen. Durch technologiegestützte Verfahren haben unsere Analysten Einblicke in Unternehmen aller Größe und Sektoren.',
          image: 'eh.png',
          link: 'https://www.eulerhermes.de',
          height: '50'
        },
        {
          title: 'Hostingwerft',
          text: 'Die Gründung der Hostingwerft steht dafür, mit leidenschaftlicher Leistung und Expertise, Hosting für Unternehmen <strong>einfach zu gestalten</strong>. Denn bei der Vielzahl an Hosting-Anbietern ist es ein mühsamer Weg und keine leichte Entscheidung, den richtigen zu finden. Wir wollen Ihnen nicht weis­ma­chen, wir seien der perfekte Hoster. Was wir Ihnen bieten, ist Ehrlichkeit und Transparenz.',
          image: 'hostingwerft.png',
          link: 'https://www.hostingwerft.de',
          height: '100'
        },
        {
          title: 'Friedrich-Naumann-Stiftung',
          text: 'Die Friedrich-Naumann-Stiftung für die Freiheit bietet auf Grundlage der Idee des Liberalismus Angebote zur Politischen Bildung in Deutschland und in aller Welt. Mit unseren Veranstaltungen und Publikationen helfen wir Menschen, sich aktiv im politischen Geschehen einzumischen. Begabte junge Menschen fördern wir durch Stipendien. Seit 2007 ist der Zusatz „für die Freiheit“ Bestandteil unseres Stiftungsnamens. Denn die Freiheit hat keine gute Konjunktur im Deutschland dieser Tage. Umso wichtiger ist es, für Freiheit zu werben und darum, die Verantwortung wahrzunehmen, die mit Freiheit einhergeht. Wir tun dies seit unserer Gründung am 19. Mai 1958. Unsere Geschäftsstelle ist in Potsdam, Büros unterhalten wir in ganz Deutschland und über 60 Ländern der Welt.',
          image: 'fnf.jpg',
          link: 'http://www.freiheit.org',
          height: '100'
        },
        {
          title: 'Gemeinsam Perspektiven entwickeln',
          text: 'Die Wirtschaftsfördergesellschaft Vorpommern steht Unternehmen kostenfrei bei allen Investitionsvorhaben als Lotse zur Seite. Neben der Informationsermittlung für Ansiedlungsvorhaben, der Objektrecherche und Standortberatung vermittelt die regionale Wirtschaftsförderung Kontakte zu relevanten Partnern und Akteuren in der Region sowie Entscheidungsträgern und hilft bei Förder- und Finanzierungsfragen.<br>Wirtschaftsfördergesellschaft Vorpommern mbH<br>Brandteichstraße 20 / 17489 Greifswald / Telefon 03834/550 605<br>www.invest-in-vorpommern.de<br>www.deutschlands-sonnendeck.de',
          image: 'wfg.jpg',
          link: 'https://www.invest-in-vorpommern.de',
          height: '90'
        },
        {
          title: 'SEO Profi Berlin',
          text: 'SEO Profi Berlin ist die Onlinemarketing-Unit der dskom GmbH aus Berlin. Sven Deutschländer und sein Team arbeiten vor allem für kleine und mittelständische Unternehmen, Start-Ups, Handwerk und Handel. Der SEO Profi Berlin bietet ein umfangreiches Programm an Beratung und Workshops, Schulungen und Seminaren an. Alle Schulungsangebote sind auch individuell buchbar – als Inhouse-Seminar vor Ort oder als Workshop-Tag im voll ausgestatteten Seminarraum des SEO Profi in Berlin.',
          image: 'seo-profi-berlin.jpg',
          link: 'https://www.seo-profi-berlin.de',
          height: '125'
        },
        {
          title: 'Jackle & Heidi',
          text: 'Wir von „Jackle & Heidi“ haben ein leidenschaftliches Verhältnis mit leckerer Eiscreme. Am Anfang unserer romantischen Beziehung war es „nur“ ein Techtelmechtel, bei dem wir wild in der heimischen Garage mit Zutaten spielten. Die Liaison wurde immer ernster, brachte uns regelmäßig zum Schmelzen und genau deswegen lassen wir die „(Eis)bombe“ platzen.',
          image: 'jackle-heidi.png',
          link: 'https://www.jackle-heidi.com',
          height: '150'
        },
        {
          title: 'Fotofecktory',
          text: 'Cordula Feck ist ausgebildete Fotografin mit dem Schwerpunkt der Werbe-, Industrie- und Portrait-Fotografie.  Von der Komposition des Bildes, bis zum fertigen Druck spürt man ihre Begeisterung und ihren Feinsinn für eine individuelle Bildsprache. Sie liebt und lebt das Handwerk der Fotografie. Daher freuen wir uns ganz besonders, dass Sie sich die Zeit nimmt, unser Event den ganzen Tag lang zu begleiten.',
          image: 'fotof.png',
          link: 'https://www.fotofecktory.de',
          height: '125'
        },
        {
          title: 'Daniela Müller projects',
          text: 'Die Stralsunder Unternehmerin Daniela Müller liebt es, neue Herausforderungen und spannende Projekte anzugehen. Sie engagiert sich in der Gesundheitsfürsorge, der Betreuung von Kindern und gründet gerade ihre eigene Stiftung.<br>Sie begeistert sich für digitale Themen, fördert digitale Bildung und stärkt Unternehmerinnen in der Region Vorpommern den Rücken.',
          image: 'daniela-mueller.png',
          height: '100'
        },
        {
          title: 'Boddenfilms',
          image: 'boddenfilms.png',
          height: '140'
        },
        {
          title: 'Anders Consulting',
          image: 'anders-consulting.png',
          height: '50'
        },
        {
          title: 'Hans Freitag',
          image: 'hansfreitag.png',
          height: '100'
        }
      ],

      hosts: [
        {
          title: 'Mecklenburg-Vorpommern',
          image: 'MV_Claim_L_RGB.jpg',
          link: 'https://www.mecklenburg-vorpommern.de',
          height: '200'
        },
        {
          title: 'Universität Greifswald',
          text: 'Die Universität Greifswald gehört zu den ältesten Universitäten in Mitteleuropa und teilt seit 1456 ihr Wissen mit ihren Studenten. Das Zentrum für Forschungsförderung und Transfer (ZFF) – als zentrale Einrichtung der Universität – fördert mit seinen UNIQUE Wettbewerben die wissensbasierte Ausgründung von Studierenden und Forschenden.<br><br>Mit MV.digital veranstaltet die Universität ein praxisnahes Format rund um die Themen der Digitalisierung mit hoher Wissensdichte.',
          image: 'universitaet-greifswald.png',
          link: 'https://www.uni-greifswald.de',
          height: '75'
        },
        {
          title: 'Inter Medien Networks',
          text: 'Die Digitalagentur Inter Medien Networks ist der Ideengeber des Formates MV.digital. Die Zusammenarbeit mit der Universität Greifwald – der Alma Mater der Gründerin von Inter Medien – ist der ideale Weg, Wissen direkt dort zu bündeln und zu teilen, wo es gerne willkommen ist.<br><br>Als Ansprechpartner steht die Agentur für alle organisatorischen Belange rund um die Konferenz zur Verfügung.',
          image: 'inter-medien.png',
          link: 'http://inter-medien.com',
          height: '50'
        }
      ],

      media: [
        {
          title: 'SocialHub',
          image: 'socialhub.png',
          link: 'https://socialhub.io',
          height: '50'
        },
        {
          title: 'Website Boosting',
          image: 'website-boosting.jpg',
          link: 'https://www.websiteboosting.com',
          height: '100'
        }
      ]
    }
  }
}
</script>
